"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _java = _interopRequireDefault(require("highlight.js/lib/languages/java"));

var _default = _java.default;
exports.default = _default;